export const AUTH_POLICY_EXPLICIT = "explicit";

const getAuthorizationHeader = (headers) => {
  if (!headers) return undefined;

  if (typeof headers.get === "function") {
    return headers.get("Authorization");
  }

  return headers.Authorization || headers.authorization;
};

export const createAuthorizationRequestInterceptor = ({
  userToken,
  temporaryToken,
}) => {
  return (config) => {
    if (getAuthorizationHeader(config.headers)) {
      config.onegradAuthPolicy = AUTH_POLICY_EXPLICIT;
      return config;
    }

    const token = userToken || temporaryToken;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  };
};

export const shouldAttemptSessionRefresh = (error) => {
  const request = error?.config;
  const requestPath = request?.url?.split("?")[0];

  return Boolean(
    error?.response?.status === 401 &&
      request &&
      requestPath !== "/auth/login" &&
      !request._retry &&
      request.onegradAuthPolicy !== AUTH_POLICY_EXPLICIT
  );
};

export const shouldClearTemporaryToken = ({ userToken, temporaryToken }) =>
  Boolean(userToken && temporaryToken);
